import { ApiCaller, Utils } from "../../config";
import { put } from "redux-saga/effects";
import CompanyOnboardingAction from "../actions/CompanyOnboardingAction";
import { SubscriptionsAction } from "../actions";

export default class SubscriptionsMiddleware {
    static *GetSubscriptions(params) {
        const { cb } = params
        try {
            const res = yield ApiCaller.Get('/subscriptions/get');
            if (res.status == 200) {
                yield put(SubscriptionsAction.GetSubscriptionsSuccess(res?.data?.data))
                cb && cb()
            }
        }
        catch (err) {
            yield put(SubscriptionsAction.GetSubscriptionsFailure());
            Utils.showMessage('error', err?.response?.data?.message)
        }
    }

    static *CreateSubscriptionSession(params) {
        const { payload, cb } = params
        try {
            const res = yield ApiCaller.Get(`/subscription/session/ceate?id=${payload.id}&isTrial=${payload.isTrial ? 1 : 0}`);
            if (res.status == 200 || res.status == 201) {
                cb && cb()
            }
        }
        catch (err) {
            Utils.showMessage('error', err?.response?.data?.message)
        }
    }
}